module.exports = __webpack_public_path__ + "img/selected6-min.e54eb440.png";